import { Component } from '@angular/core';
import { soundpostReportOutputDeferredRevenueByScheduleEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Deferred Revenue By Schedules') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputdeferredrevenuebyschedule-form',
    templateUrl: './soundpostreportoutputdeferredrevenuebyschedule.form.component.html'
})
export class soundpostReportOutputDeferredRevenueByScheduleFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputDeferredRevenueByScheduleEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

